module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat1@2x-797985a9aeaca91f6957ff78d0c15f84.jpg";